import React, { createContext, useContext, useState } from "react";

const UserDataContext = createContext<any>({
  userData: [],
  setUserData: () => null,
});
export const useUserDataContext = () => useContext(UserDataContext);

export const UserDataProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [userData, setUserData] = useState<any>();

  return (
    <UserDataContext.Provider
      value={{ userData, setUserData }}
    >
      {children}
    </UserDataContext.Provider>
  );
};
